import React from 'react';
import Switch from 'react-switch';
import { useTranslation } from 'react-i18next';
import { BaseModal } from '../BaseModal/BaseModal';
import { Button } from '../../FormComponents/Buttons/Button';
import './CookiePreferencesModal.scss';

type Props = {
  isOpen: boolean;
  handleCloseModal: () => void;
  isAnalyticsOn: boolean;
  onToggleAnalytics: (isOn: boolean) => void;
  onEnableAll: () => void;
  onSave: () => void;
};

export const CookiePreferencesModal = ({
  isOpen,
  handleCloseModal,
  isAnalyticsOn,
  onToggleAnalytics,
  onEnableAll,
  onSave,
}: Props) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      isOpen={isOpen}
      handleCloseModal={handleCloseModal}
      ariaHideApp={true}
      title="cookiebar.preferencesModal.title"
    >
      <div className="cookie-preferences-modal">
        <p className="cookie-preferences-modal__intro">{t('cookiebar.preferencesModal.intro')}</p>
        <div className="cookie-preferences-modal__category">
          <h3 className="cookie-preferences-modal__category-title">
            {t('cookiebar.preferencesModal.strictlyNecessary.title')}
          </h3>
          <p className="cookie-preferences-modal__category-description">
            {t('cookiebar.preferencesModal.strictlyNecessary.description')}
          </p>
          <div className="cookie-preferences-modal__toggle">
            <Switch
              checked={true}
              disabled={true}
              onChange={() => {}}
              onColor="#EC9A1E"
              checkedIcon={false}
              uncheckedIcon={false}
            />
            <span className="cookie-preferences-modal__toggle-label cookie-preferences-modal__toggle-label--on">
              {t('cookiebar.preferencesModal.enabledStatus')}
            </span>
          </div>
        </div>
        <div className="cookie-preferences-modal__category">
          <h3 className="cookie-preferences-modal__category-title">
            {t('cookiebar.preferencesModal.analytics.title')}
          </h3>
          <p className="cookie-preferences-modal__category-description">
            {t('cookiebar.preferencesModal.analytics.description')}
          </p>
          <div className="cookie-preferences-modal__toggle">
            <Switch
              checked={isAnalyticsOn}
              onChange={onToggleAnalytics}
              onColor="#EC9A1E"
              checkedIcon={false}
              uncheckedIcon={false}
            />
            <span
              className={`cookie-preferences-modal__toggle-label ${
                isAnalyticsOn
                  ? 'cookie-preferences-modal__toggle-label--on'
                  : 'cookie-preferences-modal__toggle-label--off'
              }`}
            >
              {t(
                isAnalyticsOn
                  ? 'cookiebar.preferencesModal.enabledStatus'
                  : 'cookiebar.preferencesModal.disabledStatus',
              )}
            </span>
          </div>
        </div>
        <div className="cookie-preferences-modal__button-row">
          <Button
            type="button"
            translationKey="cookiebar.preferencesModal.enableAllButton"
            variant="filled"
            colour="gray"
            onClick={onEnableAll}
            additionalClassName="mr-3 py-2 px-5"
          ></Button>
          <Button
            type="button"
            translationKey="cookiebar.preferencesModal.saveButton"
            variant="outlined"
            colour="black"
            onClick={onSave}
            additionalClassName="py-2 px-5"
          ></Button>
        </div>
      </div>
    </BaseModal>
  );
};
